export const GET_GROUP_PLANS = 'GET_GROUP_PLANS'
export const GET_GROUP_PLANS_SUCCESS = 'GET_GROUP_PLANS_SUCCESS'
export const GET_GROUP_PLANS_FAILURE = 'GET_GROUP_PLANS_FAILURE'
export const SELECT_GROUP_PLAN = 'SELECT_GROUP_PLAN'

export interface GroupPlansState {
  plans: any
  isFetching: boolean
  hasFetched: boolean
  errorMessage: string | null
  selectedPlan: string | null
}
